import { useEffect } from "react";

/**
 * Minimal SEO hook — sets document.title, meta description, canonical,
 * OG and Twitter tags per page, and restores defaults on unmount.
 */
export function useSeo({ title, description, path }) {
  useEffect(() => {
    const prev = {
      title: document.title,
    };

    const setMeta = (selector, attr, content) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [_, key, val] = /\[(\w+)="([^"]+)"\]/.exec(selector) || [];
        if (key) el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, content);
      return el;
    };

    if (title) document.title = title;
    const canonicalHref = `https://sanvioro.cz${path || "/"}`;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalHref;

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }

    return () => {
      if (prev.title) document.title = prev.title;
    };
  }, [title, description, path]);
}
